import { computed, defineComponent, onMounted, ref } from 'vue'
import { getCreationSettings, saveCreationSettings } from './api'

const DEFAULT_SETTINGS = {
  hall_creation_enabled: false,
  memorial_creation_enabled: false
}

function normalizeSettings(response) {
  const data = response && response.data !== undefined ? response.data : response
  if (
    !data ||
    typeof data.hall_creation_enabled !== 'boolean' ||
    typeof data.memorial_creation_enabled !== 'boolean'
  ) {
    throw new Error('创建设置返回异常，请重试')
  }
  return {
    hall_creation_enabled: data.hall_creation_enabled,
    memorial_creation_enabled: data.memorial_creation_enabled
  }
}

export default defineComponent({
  name: 'CreateManagementView',
  setup() {
    const form = ref({ ...DEFAULT_SETTINGS })
    const savedSettings = ref({ ...DEFAULT_SETTINGS })
    const loaded = ref(false)
    const loading = ref(false)
    const saving = ref(false)
    const loadError = ref('')
    const saveError = ref('')
    const successMessage = ref('')
    const hasChanges = computed(() =>
      form.value.hall_creation_enabled !== savedSettings.value.hall_creation_enabled ||
      form.value.memorial_creation_enabled !== savedSettings.value.memorial_creation_enabled
    )

    const clearFeedback = () => {
      saveError.value = ''
      successMessage.value = ''
    }

    const fetchSettings = async () => {
      if (loading.value || saving.value) return
      loading.value = true
      loaded.value = false
      loadError.value = ''
      clearFeedback()
      try {
        const settings = normalizeSettings(await getCreationSettings())
        form.value = { ...settings }
        savedSettings.value = { ...settings }
        loaded.value = true
      } catch (error) {
        loadError.value = error.message || '加载创建设置失败，请重试'
      } finally {
        loading.value = false
      }
    }

    const handleSave = async () => {
      if (!loaded.value || loading.value || saving.value || !hasChanges.value) return
      saving.value = true
      clearFeedback()
      try {
        const settings = normalizeSettings(await saveCreationSettings({ ...form.value }))
        form.value = { ...settings }
        savedSettings.value = { ...settings }
        successMessage.value = '创建设置已保存'
      } catch (error) {
        saveError.value = error.message || '保存失败，请重试'
      } finally {
        saving.value = false
      }
    }

    onMounted(fetchSettings)

    return {
      form,
      loaded,
      loading,
      saving,
      loadError,
      saveError,
      successMessage,
      hasChanges,
      clearFeedback,
      fetchSettings,
      handleSave
    }
  }
})
